module.exports = __webpack_public_path__ + "img/ch17.1aa6f3e7.png";